var map = {
	"./asset-after-sales-manage-active.svg": "./src/assets/images/menus/asset-after-sales-manage-active.svg",
	"./asset-after-sales-manage.svg": "./src/assets/images/menus/asset-after-sales-manage.svg",
	"./asset-launch-manage-active.svg": "./src/assets/images/menus/asset-launch-manage-active.svg",
	"./asset-launch-manage.svg": "./src/assets/images/menus/asset-launch-manage.svg",
	"./company-mange.svg": "./src/assets/images/menus/company-mange.svg",
	"./distribute-manage-active.svg": "./src/assets/images/menus/distribute-manage-active.svg",
	"./distribute-manage.svg": "./src/assets/images/menus/distribute-manage.svg",
	"./financial-manage-active.svg": "./src/assets/images/menus/financial-manage-active.svg",
	"./financial-manage.svg": "./src/assets/images/menus/financial-manage.svg",
	"./logs-active.svg": "./src/assets/images/menus/logs-active.svg",
	"./logs.svg": "./src/assets/images/menus/logs.svg",
	"./master-data-manage-active.svg": "./src/assets/images/menus/master-data-manage-active.svg",
	"./master-data-manage.svg": "./src/assets/images/menus/master-data-manage.svg",
	"./permission-manage-active.svg": "./src/assets/images/menus/permission-manage-active.svg",
	"./permission-manage.svg": "./src/assets/images/menus/permission-manage.svg",
	"./place-manage-active.svg": "./src/assets/images/menus/place-manage-active.svg",
	"./place-manage.svg": "./src/assets/images/menus/place-manage.svg",
	"./stocktaking-manage-active.svg": "./src/assets/images/menus/stocktaking-manage-active.svg",
	"./stocktaking-manage.svg": "./src/assets/images/menus/stocktaking-manage.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/menus sync recursive ^\\.\\/.*\\.svg$";